import ReactDOM from 'react-dom/client'
import {PortalApp} from './PortalApp'
import {PortalSidebar} from "./PortalSidebar";
import 'components/src/lang/i18n.js';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'components/src/styles/variables.css';
import 'components/src/fonts/Manrope-VariableFont_wght.ttf'

ReactDOM.createRoot(document.getElementById('root')!).render(
    <PortalApp Sidebar={PortalSidebar}/>
)
